<template>
  <div>
    <div class="card is-shadowless">
      <div class="card-header is-shadowless">
        <SideMenu></SideMenu>
      </div>
      <div class="card-content">
        <h1 class="title">Reset</h1>
        <form action="#" @submit.prevent="resetMe">
          <div class="field">
            <label for="email" class="label">Email</label>

            <div class="control">
              <input
                id="email"
                type="email"
                class="input"
                name="email"
                value
                required
                autofocus
                v-model="email"
              />
            </div>
          </div>
          <div class="field" style="">
            <div class="control">
              <button id="resetBtn" type="submit" class="button mt-3">Reset Password</button>
            </div>
          </div>
        </form>
        <div v-if="msg" :class="{'is-danger':isError, 'is-success':!isError}" class="notification is-light mt-5">{{msg}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { passwordReset } from '@/firebaseService.js'
export default {

  name: 'PasswordReset',

  data () {
    return {
      email: '',
      msg: '',
      isError: null
    }
  },
  methods: {
    resetMe () {
      passwordReset(this.email)
        .then(() => {
          this.isError = false
          this.msg = 'A password reset email has been sent to you. Please check your emails to continue'
        })
        .catch((error) => {
          this.isError = true
          this.msg = error.message
        })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
